define('home/views/NotificationCardThreadInviteView',[
    'home/views/common/ActivityCardView',
    'home/mixins/withReason',
    'home/mixins/asNotificationCard',

    'home/mixins/withTruncate',

    'home/templates/notificationCardThreadInvite',
], function (
    ActivityCardView,
    withReason,
    asNotificationCard,

    withTruncate,

    notificationCardInviteThreadTemplate
) {
    'use strict';

    var parent = ActivityCardView;

    var NotificationCardThreadInviteView = parent.extend({
        className: 'card-notif-invite card-notif-note',

        template: notificationCardInviteThreadTemplate,

        templateHelpers: function () {
            return {
                threadDescription: this.model.thread.getPlainDescription(),
                image: this.model.thread.getImage(),
                numTitleLines: 3,
            };
        },

        initialize: function () {
            this.listenTo(this.model.thread, 'change:content', this.render);
        },

        // By defining this, the asNotificationCard mixin will add in the view/click
        // tracking calls.
        getAnalyticsPayload: function (verb) {
            var thread = this.model.thread;
            var backendId = this.model.activities[0].get('backendId');
            return {
                verb: verb,
                object_type: 'note',
                object_id: backendId,
                note_template_id: backendId,
                note_template_name: ['thread', 'invite', thread.forum.id, thread.get('slug')].join(' '),
            };
        },
    });

    withReason.call(NotificationCardThreadInviteView.prototype);
    asNotificationCard.call(NotificationCardThreadInviteView.prototype);
    withTruncate.call(NotificationCardThreadInviteView.prototype);

    return NotificationCardThreadInviteView;
});

